module.exports = __webpack_public_path__ + "static/media/video-placeholder.3493567f.jpg";